export enum TemplateStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum TemplateActionStatus {
  draft = 'Save as Draft',
  publish = 'Publish',
  view = 'View',
  edit = 'Edit',
  clone = 'Clone',
  move = 'Move',
  toggleWordExport = 'Toggle Word Export',
  share = 'Share',
  unshare = 'Unshare',
}
